import { Link, useParams } from "react-router-dom";
import Button from '@mui/material/Button';
import testimonialImage from '../../../Assets/Images/Congregation/Chris-Martinez-testimonial.png';
// import topQ from '../../Assets/Images/Congregation/topQ.svg';
import topQ from '../../../Assets/Images/Congregation/leftQuote.png';
import bottomQ from '../../../Assets/Images/Congregation/rightQuote.png';
import quotation from "../../../Assets/Images/Congregation/quote-single.png";

const Testimonial = () => {

  const { id } = useParams();

  return (
    <div className="testimonial-container">
        <div className="testimonial">
        <div className="testi">
            <div className="quotation-mark"><img src={topQ} alt="quote icon" /></div>
            <p>This assessment helped our church think through internal and external engagement strategies, refine them, and make intentional moves to improve them. It helped us find blind spots, identify barriers, and start the conversations needed to improve our church.</p>
            
            <div className="quotation-mark bottom"><div className="quotation-block"><img src={bottomQ} style={{transform:'rotate(180deg)'}} alt="quote icon" /></div></div>
            
          </div>
        <div>
          <div className="avatar">
            <img src={testimonialImage} alt="pastor" width={125} height={125} />
          </div>
        </div>
        <div style={{display:'flex', justifyContent:'center' , flexDirection:'column', alignItems:'center'}}>          
          <div className="designation">
          Chris Martinez<p className="designation-inner">Lead Pastor, <span>Lakeside Church</span></p> 
          </div>
        </div>
          {/* <div className="cta-btn">
          <Link to={"/invite-team/" + id} target="_blank">
          <Button>DISCOVER YOUR PRIORITY</Button>
          </Link>
        </div> */}
        </div>
      </div>
  );
}

export default Testimonial;
